/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

/**
 * All of the possible `JobType*`'s.
 */
export type JobType = JobTypeJob | JobTypeManifest | JobTypeContext | JobTypeExecution;

/**
 * The job type.
 */
type JobTypeJob = typeof JOB_TYPE_JOB;
/**
 * The job manifest type.
 */
type JobTypeManifest = typeof JOB_TYPE_MANIFEST;
/**
 * The job context type.
 */
type JobTypeContext = typeof JOB_TYPE_CONTEXT;
/**
 * The job execution type.
 */
type JobTypeExecution = typeof JOB_TYPE_EXECUTION;

/**
 * The job constant.
 */
export const JOB_TYPE_JOB = 'job';

/**
 * The job manifest constant.
 */
export const JOB_TYPE_MANIFEST = 'manifest';

/**
 * The job context constant.
 */
export const JOB_TYPE_CONTEXT = 'context';

/**
 * The job execution constant.
 */
export const JOB_TYPE_EXECUTION = 'jobExecution';
